import {
  ResponseVerificarNombre,
  VerificarNombreParams,
} from '@/types/verifyName';
import axiosGdt from '@/utils/axiosGdt';
import { URLs } from '@/utils/urls';

export const verificarNombre = async (params: VerificarNombreParams) => {
  const response = await axiosGdt.post<ResponseVerificarNombre>(
    URLs.EDITAR_DATOS_2.VERIFICAR_NOMBRE,
    params,
    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
  );
  return response.data;
};
